import { useHasPermission } from '@app/core/auth/authorization';
import { auditReportsPermissions } from '@app/modules/audit/audit-reports-permissions';
import { AodRule } from '@app/modules/audit/modules/aod/aod.types';
import { useRouter } from '@mi-front/core';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { aodRoutes } from '../../../routing/routes';
import { AodRuleDeleteButton } from './AodRuleDeleteButton';

interface AodRuleActionsProps {
  rule: AodRule;
}

export function AodRuleActions({ rule }: AodRuleActionsProps) {
  const { formatMessage } = useIntl();
  const { history } = useRouter();
  const canManage = useHasPermission(auditReportsPermissions.AodRules_Manage);

  const handleEdit = () => {
    history.push(aodRoutes.ruleEdit.gen(rule.id));
  };

  return (
    <div style={{ display: 'flex', gap: '0.5rem' }}>
      {canManage && (
        <Button size="small" variant="outlined" startIcon={<EditIcon />} onClick={handleEdit}>
          {formatMessage({
            id: 'common.actions.edit',
            defaultMessage: 'Editar',
          })}
        </Button>
      )}
      {canManage && <AodRuleDeleteButton rule={rule} />}
    </div>
  );
}
